import {animate, state, style, transition, trigger} from '@angular/animations';

export const EnterFromTop =
    trigger('enterFromTop', [
        state('in',
            style({
                transform: 'translateY(0)',
                opacity: 1
            })
        ),
        transition('void => *', [
            style({
                transform: 'translateY(-100%)',
                opacity: 0
            }),
            animate('0.25s ease-out')
        ])
    ]);
